import { render, staticRenderFns } from "./TaskOverdueFrom.vue?vue&type=template&id=55406ebd"
import script from "./TaskOverdueFrom.vue?vue&type=script&lang=js"
export * from "./TaskOverdueFrom.vue?vue&type=script&lang=js"
import style0 from "./TaskOverdueFrom.vue?vue&type=style&index=0&id=55406ebd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports